export default {
  lookUpCliniqueCode(cliniqueId, cliniqueCode, skipErrorHandler = false) {
    return this.post(`/clinique/lookup-code`, { cliniqueId, cliniqueCode }, skipErrorHandler)
      .then((responseData) => responseData);
  },
};
